import React from 'react';
import { useNavigate } from 'react-router-dom'; // 1. IMPORTAR HOOK
import { Ghost, Home, ArrowLeft } from 'lucide-react';

const NotFound = ({ language }) => { // Ya no recibimos navigateTo
  
  // 2. INICIALIZAR HOOK
  const navigate = useNavigate();

  const t = {
    es: {
      title: '404',
      subtitle: '¡Ups! Página no encontrada',
      desc: 'Parece que te has desviado del camino. La página que buscas no existe o ha sido movida.',
      btnHome: 'Volver al Inicio',
      btnBack: 'Regresar'
    },
    en: {
      title: '404',
      subtitle: 'Oops! Page not found',
      desc: "It seems you've gone off path. The page you are looking for doesn't exist or has been moved.",
      btnHome: 'Back to Home',
      btnBack: 'Go Back'
    }
  };

  const text = t[language] || t.es;

  return (
    <div className="pt-32 pb-20 min-h-screen bg-gray-50 font-[Poppins] flex items-center justify-center relative overflow-hidden">
      
      {/* Fondo Decorativo */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[100px] -mr-32 -mt-32"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-cyan-600/5 rounded-full blur-[100px] -ml-32 -mb-32"></div>

      <div className="relative z-10 text-center px-4 max-w-lg mx-auto">
        
        {/* Icono Animado */}
        <div className="inline-flex justify-center items-center w-32 h-32 bg-white rounded-full shadow-xl mb-8 animate-bounce">
          <Ghost size={64} className="text-purple-600" />
        </div>

        {/* Texto Principal */}
        <h1 className="text-8xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-cyan-500 mb-2">
          {text.title}
        </h1>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
          {text.subtitle}
        </h2>
        <p className="text-gray-500 text-lg mb-10 leading-relaxed">
          {text.desc}
        </p>

        {/* Botones de Acción */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => navigate('/')} // 3. Ir al Home
            className="flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 rounded-2xl shadow-lg transition-all transform hover:-translate-y-1"
          >
            <Home size={20} />
            {text.btnHome}
          </button>
          
          <button 
            onClick={() => navigate(-1)} // 3. Ir Atrás en historial (-1)
            className="flex items-center justify-center gap-2 bg-white border-2 border-gray-200 text-gray-600 hover:border-purple-300 hover:text-purple-600 font-bold py-4 px-8 rounded-2xl transition-all"
          >
            <ArrowLeft size={20} />
            {text.btnBack}
          </button>
        </div>

      </div>
    </div>
  );
};

export default NotFound;